import ShippingInfoModelBase from '../_generated/modelBases/shipping-info-model-base';

export default class ShippingInfoModel extends ShippingInfoModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
